/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RoleInputs */

const th_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทบาท`)
};

const en_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const ja_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`役割`)
};

const zh_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const es_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

const pt_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Função`)
};

const id_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peran`)
};

const fr_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rôle`)
};

const tl_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkulin`)
};

const vi_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai trò`)
};

const ko_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`역할`)
};

const de_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle`)
};

const ru_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роль`)
};

const tr_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

const it_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruolo`)
};

const pl_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rola`)
};

const uk_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роль`)
};

const hi_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भूमिका`)
};

const ar_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدور`)
};

const ms_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peranan`)
};

const bn_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভূমিকা`)
};

const zh_tw2_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const zh_hk2_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const ur_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کردار`)
};

const fa_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقش`)
};

const sw_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi`)
};

const nl_role = /** @type {(inputs: RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {RoleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const role = /** @type {((inputs?: RoleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RoleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_role(inputs)
	if (locale === "ja") return ja_role(inputs)
	if (locale === "zh") return zh_role(inputs)
	if (locale === "es") return es_role(inputs)
	if (locale === "pt") return pt_role(inputs)
	if (locale === "id") return id_role(inputs)
	if (locale === "fr") return fr_role(inputs)
	if (locale === "tl") return tl_role(inputs)
	if (locale === "vi") return vi_role(inputs)
	if (locale === "ko") return ko_role(inputs)
	if (locale === "de") return de_role(inputs)
	if (locale === "ru") return ru_role(inputs)
	if (locale === "tr") return tr_role(inputs)
	if (locale === "it") return it_role(inputs)
	if (locale === "pl") return pl_role(inputs)
	if (locale === "uk") return uk_role(inputs)
	if (locale === "hi") return hi_role(inputs)
	if (locale === "ar") return ar_role(inputs)
	if (locale === "ms") return ms_role(inputs)
	if (locale === "bn") return bn_role(inputs)
	if (locale === "zh-TW") return zh_tw2_role(inputs)
	if (locale === "zh-HK") return zh_hk2_role(inputs)
	if (locale === "ur") return ur_role(inputs)
	if (locale === "fa") return fa_role(inputs)
	if (locale === "sw") return sw_role(inputs)
	if (locale === "nl") return nl_role(inputs)
	return en_role(inputs)
});